/* eslint-disable camelcase */
import { mountStoreDevtool } from 'simple-zustand-devtools';
import { create } from 'zustand';

interface UTMParams {
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_content: string;
}

const defaultUTMParams = {
  utm_source: null,
  utm_medium: null,
  utm_campaign: null,
  utm_content: null
};

interface State {
  setUTMParams: (params: UTMParams) => void;
  deleteUTMParams: () => void;
  utmParams: UTMParams;
}

const useUTMStore = create<State>()((set) => ({
  utmParams: defaultUTMParams,
  setUTMParams: (params) => set({ utmParams: params }),
  deleteUTMParams: () => set({ utmParams: defaultUTMParams })
}));

if (process.env.NEXT_PUBLIC_ENV === 'dev' && typeof window !== 'undefined') {
  mountStoreDevtool('UTMStore', useUTMStore);
}

export default useUTMStore;
